export default __webpack_public_path__ + "static/users-07d68eb497864d3ac522324029a8c23b.png";